import React from 'react';

const MapLegend: React.FC = () => {
  return (
    <>
      <div className="legend">
        <div className="legend-color waiting" />
        <div className="legend-text">Waiting</div>
      </div>
      <div className="legend">
        <div className="legend-color complete" />
        <div className="legend-text">All received</div>
      </div>
      <div className="legend">
        <div className="legend-color expired" />
        <div className="legend-text">Expired</div>
      </div>
    </>
  );
};

export default React.memo(MapLegend);
